import React from 'react';

import { Helmet } from 'react-helmet';

import { Box, Container, Tab, Tabs } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';
import SectionNavigation from '~/components/Common/Elements/SectionNavigation';
import SectionNavigationLayout from '~/components/Common/Elements/SectionNavigationLayout';
import { preRegisterSpotlightRoutes } from '~/components/Common/Spotlight/SpotlightProvider';

import useAppNavigation from '~/hooks/useAppNavigation';
import useCurrentUser from '~/hooks/useCurrentUser';
import useQuery from '~/hooks/useQuery';

import {
  flightsLeafTabs,
  flightsPrimaryTabs,
  getFlightsLeafSlugForPrimaryTab,
  getFlightsSecondaryTabs,
  resolveFlightsTabSelection,
} from './flightsTabs';

preRegisterSpotlightRoutes(
  flightsLeafTabs.map((tab) => ({
    path: `/flights?tab=${tab.slug}`,
    label: `Flights / ${tab.label}`,
    section: 'Flights',
  })),
);

export function FlightsPageContainer() {
  const query = useQuery();
  const { push } = useAppNavigation();
  const { user } = useCurrentUser();
  const selectedTab = query.get('tab');
  const { activeLeafTab, activeLeafSlug, activePrimaryTab, activePrimarySlug } =
    resolveFlightsTabSelection(selectedTab);
  const secondaryTabs = getFlightsSecondaryTabs(activePrimaryTab);
  const visibleSecondaryTabs = secondaryTabs.filter(
    (tab) => !tab.requiredRoles?.length || tab.requiredRoles.some((role) => user?.roles.includes(role)),
  );
  const visibleActiveLeafSlug = visibleSecondaryTabs.some((tab) => tab.slug === activeLeafSlug)
    ? activeLeafSlug
    : false;
  const isPrimaryTabGrouped = secondaryTabs.length > 0;

  const title = `Flights / ${activeLeafTab.label}`;

  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <PageHeader title={title} />

      <SectionNavigationLayout
        navigation={
          <SectionNavigation
            label="Flights sections"
            currentTab={activePrimarySlug}
            groups={[
              {
                items: flightsPrimaryTabs.map((tab) => ({
                  id: tab.slug,
                  label: tab.label,

                  href: `/flights?tab=${getFlightsLeafSlugForPrimaryTab(tab.slug)}`,
                })),
              },
            ]}
          />
        }
      >
        {isPrimaryTabGrouped && (
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={visibleActiveLeafSlug}
              onChange={(_, selectedSecondaryTabSlug) => push(`/flights?tab=${selectedSecondaryTabSlug}`)}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              {visibleSecondaryTabs.map((tab) => (
                <Tab key={tab.slug} value={tab.slug} label={tab.label} />
              ))}
            </Tabs>
          </Box>
        )}

        <Box mt={4}>
          <Box component={activeLeafTab.component} />
        </Box>
      </SectionNavigationLayout>
    </Container>
  );
}

export default FlightsPageContainer;
